import React from "react";
import AccreditedInvestorsTable from "./investors/InvestorsList";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const AccreditedInvestors = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AccreditedInvestorsTable/>
      </div>
    </div>
  );
};

export default AccreditedInvestors;
